import DISTANCE_UNITS from '../types/distanceUnits';
import { getTransmissionType, ITradeSummary } from './TradeList';
import { TradeStateNew, TradeStateNewName } from '../types/trade';

const getTradeStateName = tradeStateId => {
  return TradeStateNewName[tradeStateId];
};

class TradeSearchList {
  tradeSearchResults: ITradeSummary[];

  tradeCount: number;

  exactMatchTrades: ITradeSummary[];

  notExactMatchTrades: ITradeSummary[];

  constructor(data: any = []) {
    this.tradeSearchResults = data ? TradeSearchList.mapTrades(data) : [];
    this.tradeCount = data && data[0] ? data[0].exactMatchTotal : 0;

    this.exactMatchTrades = this.tradeSearchResults.filter(trades => {
      return trades.exactMatch === true;
    });

    this.notExactMatchTrades = this.tradeSearchResults.filter(trades => {
      return (
        trades.exactMatch === false &&
        (trades.tradeStateName === TradeStateNewName[TradeStateNew.ACTIVE] ||
          trades.tradeStateName === TradeStateNewName[TradeStateNew.UPCOMING])
      );
    });
  }

  private static mapTrades(trades = []): ITradeSummary[] {
    const autoLaunch = {
      date: '',
      time: ''
    };
    return trades.map(t => ({
      id: t.tradeId,
      thumbnailUrl: t.thumb,
      year: t.year,
      make: t.make?.name || t.make?.displayName,
      model: t.model?.name || t.model?.displayName,
      mileage: t.mileage,
      odometerType:
        t.odometerType === 0 ? DISTANCE_UNITS.KM : DISTANCE_UNITS.MI,
      transmission: getTransmissionType(t.transmission?.id),
      exactMatch: t?.exactMatch,
      isAsIs: t?.asIs,
      hasDisclosures: t?.hasDisclosures,
      isLanded: t?.inStock,
      distance: undefined,
      isWatchlisted: undefined,
      autoLaunch,
      tradeVehicleSummary: {},
      trim: t.trim,
      vin: t.vin,
      tradeStateName: getTradeStateName(t.tradeState?.id)
    }));
  }
}

export default TradeSearchList;
